/**
 * หัตถ์ล็อกโซ่ทาง (chain-hold): its lock routine (design docs/design/combat/2026-10-11-lock-moves-13.md §2.2, kit audit
 * docs/design/combat/2026-10-13-art-kit-audit.md piece 4). The lock move is ah-grip 扣 (range 1.9, the 0.35 s lock wind-up:
 * open hand low and forward, palm up, the other hand at the belt cord). Identity: the only routine that is a hold — joint locks
 * walk the prisoner down to the ground, the cord cuffs the wrists, a shove sends it off and it leaves in a shackle
 * (`endStatus`, systems/longMove.ts). Little striking; the longest catch (0.6 s) = the most time to read and escape.
 * `prone` draws as `fall` until the receive pose exists (no hand-off to the knock-down rules: the foe is hauled up again).
 * Keys (ah* poses, joint/chain fx, grip/chain sfx) are the contract for the motion / FX / sound lanes. Data only.
 */
import { registerLongMove } from './registry';

/** 扣 ตรวนสามข้อ — wrist, elbow, shoulder; knee drop and pin; the cord cuffs; hauled up and shoved off in a shackle. */
export const THREE_LINK_SHACKLE = registerLongMove({
  skillId: 'ah-grip',
  kind: 'lock',
  name: 'ตรวนสามข้อ',
  opener: { type: 'contact', range: 0, tell: 0 },
  len: 5.8,
  catch: 0.6,
  power: 1.9,
  lunge: 0.8,
  endStatus: { status: 'shackle', dur: 2 },
  beats: [
    { at: 0, pose: 'ahWrist', hits: 0, share: 0, foe: 'hit', fx: 'jointMark', sfx: 'gripCloth', cam: 'hold' },
    { at: 0.6, pose: 'ahElbow', hits: 1, share: 0.12, foe: 'spin', ai: 2, fx: 'bootScuff', sfx: 'jointClick', cam: 'orbit' },
    { at: 1.5, pose: 'ahShoulder', hits: 1, share: 0.12, foe: 'kneel', fx: 'jointMark', sfx: 'shoulderGroan' },
    { at: 2.3, pose: 'ahKneeDrop', hits: 1, share: 0.14, foe: 'kneel', fx: 'dustPuff', sfx: 'kneeThud' },
    { at: 2.9, pose: 'ahPin', hits: 0, share: 0, foe: 'prone', fx: 'badgeGlint', sfx: 'cordDraw', cam: 'push' },
    { at: 3.7, pose: 'ahCuff', hits: 1, share: 0.22, foe: 'prone', fx: 'chainLoop', sfx: 'chainLock' },
    {
      at: 4.4,
      pose: 'ahHaulShove',
      hits: 1,
      share: 0.4,
      foe: 'knock',
      dist: 1.4,
      stop: 0.08,
      fx: 'palmBurstSmall',
      sfx: 'palmSlam',
      cam: 'shake',
    },
    { at: 5.0, pose: 'ahStance', hits: 0, share: 0, foe: 'recover', fx: 'chainFade' },
  ],
});
